const useBrand = () => {
  return {
    isMcom: import.meta.env.VITE_ENTRY_POINT === 'mcom',
    isBcom: import.meta.env.VITE_ENTRY_POINT === 'bcom',
  };
};
export default useBrand;
